import {AbstractMainPlugin} from "../../AbstractMainPlugin";
import {Item} from "../../../models/Item";
import {ItemConfig} from "../../../models/ItemConfig";
import {appInjector} from "../../appInjector";
import {ParticipantsService} from "./service/participants.service";


export class ParticipantPlugin extends AbstractMainPlugin {

  private participantService = appInjector.get(ParticipantsService);
  private oldConfig = '';

  constructor(item:Item) {
    super(item);
    this.initParticipants();
    this.initListeners();
  }

  private initParticipants(){
    let input = this.item.config.getInputByName(Item.ParticipantName);
    this.oldConfig = (input && input.value && input.value.trim().length > 0) ? JSON.stringify(input.value) : '';
    if (!input){
      this.item.config.createInputValue(Item.ParticipantName, {value: ''});
    }
  }

  private initListeners(){

    this.participantService.currentParticipant.subscribe((val)=>{
        let visibility = this.participantService.getItemVisibilityByCurrentParticipantGroup(this.item);
        this.item.setVisibility(visibility);
        this.item.setSidebarItemVisibility(visibility);
    });

    this.item.config.serverUpdate.subscribe((newConfig)=>{
      if (this.oldConfig != newConfig.getInputByName(Item.ParticipantName))
      this.onConfigUpdated(newConfig);
    });
  }

  private onConfigUpdated(newConfig:ItemConfig){
    let val = newConfig.getInputProp(Item.ParticipantName, 'value');
    let value = (val) ? val : '';
    let jsonVal = (value) ? JSON.stringify(value) : '';
    if (this.oldConfig != jsonVal){
      this.item.getSubject('participant_updated').next(value);
      this.oldConfig = JSON.stringify(val);
    }
  }
}
